import { ApiService } from "../../02_utils/apiService";
import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";
import { ChipService } from "./Services/chipService";
import { FilterInputService } from "./Services/filterInputService";
import { LoaderService } from "./Services/loaderService";
import { PaginationService } from "./Services/paginationService";
import { RenderService } from "./Services/renderService";
import { RequestService } from "./Services/requestService";
import { SearchService } from "./Services/searchService";
import { filter } from "rxjs";

export class Filter {
  private filter: HTMLElement;
  private chipService: ChipService;
  private filterInputService: FilterInputService;
  private paginationService: PaginationService;
  private loaderService: LoaderService;
  private renderService: RenderService;
  private requestService: RequestService;

  constructor(filterElement: HTMLElement, private $log: Logger, private $utils: Utils, private $apiService: ApiService) {
    this.filter = filterElement;
    this.filterInputService = new FilterInputService(this.filter, this.$log, this.$utils, this.$apiService);
    this.chipService = new ChipService(this.filter, this.$log, this.$utils);
    this.paginationService = new PaginationService(this.filter, this.$log, this.$utils);
    this.renderService = new RenderService(this.filter, this.$log, this.$utils);
    this.loaderService = new LoaderService(this.filter, this.$log, this.$utils, this.renderService);
    this.requestService = new RequestService(this.filter, this.$log, this.$utils, this.$apiService, this.loaderService, this.filterInputService);

    this.filterInputService.filters.subscribe(filters => {
      this.requestService.currentFilters = filters;
      this.chipService.currentFilters = filters;

      this.filterInputService.updateFilters();
      this.filterInputService.restrictFilters();
      this.chipService.updateChips();

      this.paginationService.page.next(1);
    });

    this.requestService.requestBody.subscribe(requestBody => {
      this.renderService.requestBody = requestBody;
      this.filterInputService.requestBody = requestBody;
    });

    this.paginationService.page.subscribe((page) => {
      this.renderService.currentPage = page;
      this.requestService.loadNextPage(page);
    });

    this.requestService.dataModel.pipe(filter(value => value != null)).subscribe((dataModel) => {
      this.renderService.render(dataModel);
      this.paginationService.pagination = dataModel.pagination;
      this.paginationService.updatePagination();
    });

    this.chipService.filters.subscribe((filters) => {
      this.filterInputService.filters.next(filters);
      this.filterInputService.updateFilters();
    });

    if (!this.filterInputService.setInitFiltersFromUrl()) {
      this.paginationService.page.next(1);
    }
  }
}
